import styled from 'styled-components';
import {Link} from "gatsby";

const StyledMenu = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  margin: 0;
`;

const Position = styled(Link)`
    font-size: ${({isMobile}) => isMobile ? '1.8rem' : ''};
    opacity: ${({isMobile}) => isMobile ? '1' : '0.6'};
    text-decoration: none;
    margin:${({isMobile}) => isMobile ? '0' : '0 0 0 42px'};
    color: black;
    transition: 0.2s ease-in-out;
    &:hover {
        opacity: 1
    }
`;

const MobileMenu = styled.div`
  opacity: ${({open}) => open ? '1' : '0'};
  transition: 0.3s ease-in-out;
  position: fixed;
  z-index: 2;
  height: 100vh;
  width: 100vw;
  max-height: 100%;
  max-width: 100%;
  top: 5%;
  left: 0;
  display: ${({open}) => open ? 'flex' : 'none'};
  flex-direction: column;
  align-items: center;
  align-content: center; 
  justify-content: space-evenly;
  background: white;
`;


export {StyledMenu, MobileMenu, Position}
